import mapKnownValues from "../../utils/mapKnownValues";

let uidCounter = 0;

export default class MailingDetails {
  firstName = "";
  lastName = "";
  addressLine1 = "";
  addressLine2 = "";
  city = "";
  state = "";
  zipcode = "";
  // eslint-disable-next-line no-plusplus
  uid = `${++uidCounter}`;

  constructor(params: Partial<MailingDetails>) {
    mapKnownValues(this, params);
  }
}
